export default (response) => {
  let blobURL = URL.createObjectURL(response.data);

  // Remove old containers
  let containers = document.querySelectorAll(".iframe-for-printing");
  containers.forEach((container) => {
    container.remove();
  });

  // Create new container
  let container = document.createElement("iframe");
  container.classList.add("iframe-for-printing");

  document.body.appendChild(container);

  container.style.display = "none";
  container.src = blobURL;
  container.onload = () => {
    setTimeout(function () {
      container.focus();
      container.contentWindow.print();
    }, 1);
  };
};
